@use "../../../../styles/util/shadow.scss" as shadow;

:host {
    display: block;
    position: absolute;
    width: 100%;
    height: 0;
    left: 0;
    top: 0;
    box-sizing: border-box;

    * {
        box-sizing: border-box;
    }

    .modal-container-ref {
        position: relative;
        width: 100%;
        height: 1px;
    }

    /*
    Variables CSS modificables desde el componente:
    --width: Ancho del modal.
    --height: Altura del modal.
    --minWidth: Ancho mínimo del modal.
    --maxWidth: Ancho máximo del modal.
    --minHeight: Altura mínima del modal.
    --maxHeight: Altura máxima del modal.
    --modalPadding: Padding interno del modal.
    --bubbleSize: Tamaño del bubble (diámetro).
    --x: Posición horizontal del bubble.
    --y: Posición vertical del bubble.
    --marginFromParentLeft: Margen mínimo desde el borde izquierdo del parent.
    --marginFromParentRight: Margen mínimo desde el borde derecho del parent.
    --marginBubbleModal: Margen entre el bubble y el modal.
    */
    .bubble-modal {
        --shadow-x: 0px;
        --shadow-y: 0px;
        width: var(--width);
        height: var(--height);
        min-width: var(--minWidth);
        max-width: var(--maxWidth);
        min-height: var(--minHeight);
        max-height: var(--maxHeight);
        top: var(--y);
        position: absolute;
        opacity: 0;
        display: flex;
        flex-direction: column;
        background-color: #fff;
        transition: top 0.3s ease-out,
            left 0.3s ease-out,
            right 0.3s ease-out,
            opacity 0.3s ease-out 0.2s, // opacidad con delay
            border-radius 0.3s ease-out,
            box-shadow 0.8s ease-out;
        padding: var(--modalPadding, var(--padding2));
        border-radius: 12px;
        border: 1px solid rgba(0, 0, 0, 0.1);
        @include shadow.shadow-floating-modal; // referencia de sombra
        box-shadow: var(--shadow-x) var(--shadow-y) 45px rgba(0, 0, 0, 0.25);

        &.left {
            --shadow-x: 10px;
            left: calc(var(--bubbleSize) + var(--marginFromParentLeft) + var(--marginBubbleModal));
        }

        &.right {
            --shadow-x: -10px;
            right: calc(var(--bubbleSize) + var(--marginFromParentRight) + var(--marginBubbleModal));
        }

        &.top {
            --shadow-y: -10px;
        }

        &.bottom {
            --shadow-y: 10px;
        }
    }

    &:has(.bubble-modal.open) {
        app-floating-bubble {
            z-index: 1;
        }
    }

    .bubble-modal.open {
        opacity: 1;
    }

    .bubble-modal.closed {
        opacity: 0;
        pointer-events: none;
    }
}